import React from "react";
import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  BULK_PROCESS_SUCCESS,
  CHECK_PRE_VERIFICATION_SUCCESS,
  CLEAR_PRE_VERIFICATION_STATE_DATA,
  CLEAR_PRE_VERIFICATION_STATE_SUCCESS,
  CREATE_PRE_VERIFICATION_SUCCESS,
  FETCH_ASSET_MODELS_SUCCESS,
  FETCH_ASSET_SUB_TYPE_SUCCESS,
  FETCH_PRE_VERIFICATION_SUCCESS,
  GET_PRE_VERIFICATION_COMBINE_REPORT_SUCCESS,
  GET_PRE_VERIFICATION_SUCCESS, GET_PV_BY_VOUCHER_SUCCESS, GET_RECXONCILIATION_ASSETS_SUCCESS,
  PRE_VERIFICATION_UPLOAD_COUNT_DECREASE,
  PRE_VERIFICATION_UPLOAD_COUNT_INCREASE, PV_QR_RESET_PROCESS_SUCCESS,
  SAVE_PRE_VERIFICATION_QUERY,
  SAVE_PRE_VERIFICATION_STATE_SUCCESS,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { message, notification, Icon } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";
import moment from "moment/moment";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_PRE_VERIFICATION_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_PRE_VERIFICATION_QUERY,
    query
  };
};

export const checkResourceSuccess = ({ data }) => {
  return {
    type: CHECK_PRE_VERIFICATION_SUCCESS,
    data
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_PRE_VERIFICATION_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_PRE_VERIFICATION_SUCCESS,
    data
  };
};

export const fetchAssetSubTypeSuccess = (data) => {
  return {
    type: FETCH_ASSET_SUB_TYPE_SUCCESS,
    data
  };
};

export const fetchAssetModelsSuccess = (data) => {
  return {
    type: FETCH_ASSET_MODELS_SUCCESS,
    data
  };
};

export const clearData = () => {
  return {
    type: CLEAR_PRE_VERIFICATION_STATE_SUCCESS,
  }
};

export const clearPropsData = () => {
  return {
    type: CLEAR_PRE_VERIFICATION_STATE_DATA,
  }
}

export const saveInitialData = (data) => {
  return {
    type: SAVE_PRE_VERIFICATION_STATE_SUCCESS,
    data
  }
};

export const preVerificationUploadCountDecrease = () => {
  return {
    type: PRE_VERIFICATION_UPLOAD_COUNT_DECREASE,
  }
}

export const preVerificationUploadCountIncrease = () => {
  return {
    type: PRE_VERIFICATION_UPLOAD_COUNT_INCREASE,
  }
}

export const getResource = (flag = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { preVerification } = store.getState();
      const { query } = preVerification;
      let response;
      if (flag) {
        response = await axios.post(`/pre-verification-approval/app`);
      } else {
        response = await axios.get(`/pre-verification?${generateQueryString(query)}`);
      }
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { preVerification } = store.getState();
      const { query } = preVerification;
      const response = await axios.get(`/pre-verification/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const checkResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/pre-verification/check`, payload);
      dispatch(fetchSuccess());
      dispatch(checkResourceSuccess({ data: response.data || '' }));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const handleSelectAssetType = (assetType) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/equipment-sub-type/by-asset-type/${assetType}`);
      dispatch(fetchSuccess());
      if (response && response.data) {
        dispatch(fetchAssetSubTypeSuccess(response.data));
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

export const handleSelectAssetSubType = (assetSubType) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-model/subType/${assetSubType}`);
      dispatch(fetchSuccess());
      if (response && response.data) {
        dispatch(fetchAssetModelsSuccess(response.data));
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

export const reOpenPvVerification = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.put(`/pre-verification/reopen/${id}`);
      dispatch(fetchSuccess());
      if (response && response.status === 200) {
        message.success('PV Reopened successfully !!');
        dispatch(getResource());
        history.goBack();
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

export const createResourceWithDocuments = (payload, countable = false, update = false, secondUpdate = false, save = false) => {
  // console.log('this... ', payload)
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      let fileData = new FormData();

      Object.keys(payload).forEach(key => {
        if (key === 'assetDetails') {
          if (payload[key] && payload[key][0] && payload[key][0]['fileData'] && payload[key][0]['fileData'].length) {
            for (let i = 0; i < payload[key][0]['fileData'].length; i++) {
              fileData.append(`files`, payload[key][0]['fileData'][i]);
            }

            if (payload[key][0]['tempAssetCode'])
              fileData.append('tempAssetCode', payload[key][0]['tempAssetCode']);

          }
          return formData.append(key, JSON.stringify(payload[key]));
        }
        formData.append(key, payload[key]);
      });

      if (fileData.has('files')) {
        if (payload && payload['_id']) {
          fileData.append('id', payload['_id']);
        } else {
          return message.error('Record Not Updated');
        }

        const kk = axios.post('/pre-verification/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
          .then(async response => {
            if (response.status === 201) {
              const { preVerification } = store.getState();
              const { astUploadCount } = preVerification;
              // if (astUploadCount) {
              //   notification.info({
              //     placement: 'bottomRight',
              //     message: `Image upload in progress`,
              //     description: `Asset's images left to be uploaded : ${astUploadCount}`,
              //   })
              // } else
              notification.destroy();
              notification.open({
                placement: 'bottomRight',
                message: `All the images have been uploaded`,
              })
            }
          });
      }
      dispatch(fetchSuccess());
      dispatch(clearData());

      // if (!update) {
      //   history.push(`/asset-stock-taking/view/${response.data._id}`);
      // } else {
      //   history.push(`/asset-stock-taking/edit/${response.data._id}`);
      //   dispatch(getResource());
      // }
      if (save) {
        history.push('/pre-verification');
      }
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const addNewPVImage = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      let fileData = new FormData();

      Object.keys(payload).forEach(key => {
        if (key === 'assetDetails') {
          if (payload[key] && payload[key][0] && payload[key][0]['fileData'] && payload[key][0]['fileData'].length) {
            for (let i = 0; i < payload[key][0]['fileData'].length; i++) {
              fileData.append(`files`, payload[key][0]['fileData'][i]);
            }

            if (payload[key][0]['tempAssetCode'])
              fileData.append('tempAssetCode', payload[key][0]['tempAssetCode']);

          }
          return formData.append(key, JSON.stringify(payload[key]));
        }
        formData.append(key, payload[key]);
      });

      if (fileData.has('files')) {
        if (payload && payload['_id']) {
          fileData.append('id', payload['_id']);
        } else {
          return message.error('Record Not Updated');
        }

        notification.destroy();
        notification.open({
          placement: 'bottomRight',
          message: <div><h4>Uploading ... </h4><Icon type={'loading'} /></div>
        })
        axios.post('/pre-verification/add-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
          .then(async response => {
            if (response.status === 201) {
              if (payload && payload['_id'])
                dispatch(fetchResource(payload['_id']));

              notification.destroy();
              notification.open({
                placement: 'bottomRight',
                message: `All the images have been uploaded`,
              })

              dispatch(fetchSuccess());
            }
          });
      }
      dispatch(fetchSuccess());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error));
    }
  }
};


export const createResource = (payload, update) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      if (payload.assetDetails) {
        payload.assetDetails = JSON.stringify(payload.assetDetails);
      }
      const response = await axios.post(`/pre-verification`, payload);
      dispatch(fetchSuccess());
      if (response && response.data && response.data.code && response.data.code === 201) {
        message.error(response.data.message);
      } else {
        dispatch(saveInitialData(response.data));
        dispatch(createResourceSuccess({ data: response.data }));
        // if (!update) {
        //   history.push(`/asset-stock-taking/view/${response.data._id}`);
        // } else {
        //   history.push(`/asset-stock-taking/edit/${response.data._id}`);
        //   dispatch(getResource());
        // }
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateTempCode = (id, payload, checked, update) => {
  // console.log('comes here');
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      if (payload.assetDetails) {
        payload.assetDetails = JSON.stringify(payload.assetDetails);
      }
      const response = await axios.put(`/pre-verification/update-temp-code/${id}`, payload);
      // console.log(response);
      dispatch(fetchSuccess());
      if (response && response.data && response.data.code && response.data.code === 201) {
        message.error(response.data.message);
      } else {
        dispatch(createResourceSuccess({ data: response.data }));
        // if (!update) {
        //   history.push(`/asset-stock-taking/view/${response.data._id}`);
        // } else {
        //   history.push(`/asset-stock-taking/edit/${response.data._id}`);
        //   dispatch(getResource());
        // }
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id, countable, update, save = false) => {
  console.log('update ... ', payload)
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      let fileData = new FormData();
      Object.keys(payload).forEach(key => {
        if (key === 'assetDetails') {
          for (let i = 0; i < payload[key][0]['fileData'].length; i++) {
            //dispatch(preVerificationUploadCountIncrease());
            fileData.append(`files`, payload[key][0]['fileData'][i]);
          }
          if (payload[key][0]['tempAssetCode'])
            fileData.append('tempAssetCode', payload[key][0]['tempAssetCode']);

          delete payload[key][0]['fileData'];
          return formData.append(key, JSON.stringify(payload[key]));
        }
        formData.append(key, payload[key]);
      });

      //const response = await axios.put(`/pre-verification/asset-details-update/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if (fileData.has('files')) {
        fileData.append('id', id);
        //dispatch(preVerificationUploadCountIncrease());
        const { preVerification } = store.getState();
        const { astUploadCount } = preVerification;
        // if (astUploadCount) {
        //   notification.info({
        //     placement: 'bottomRight',
        //     message: `Image upload in progress`,
        //     description: `Asset's images left to be uploaded : ${astUploadCount}`,
        //   })
        // }
        axios.post('/pre-verification/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
          .then(async response => {
            if (response.status === 201) {
              dispatch(preVerificationUploadCountDecrease());
              const { preVerification } = store.getState();
              const { astUploadCount } = preVerification;
              // if (astUploadCount) {
              //   notification.info({
              //     placement: 'bottomRight',
              //     message: `Image upload in progress`,
              //     description: `Asset's images left to be uploaded : ${astUploadCount}`,
              //   })
              // }
              notification.destroy();
              notification.success({
                placement: 'bottomRight',
                message: `All the images have been uploaded`,
              });
            }
          });
      }
      dispatch(fetchSuccess());
      //message.success('Asset details has been updated.');
      // if (!update) {
      //   history.push(`/asset-stock-taking/view/${id}`);
      // } else {
      //   history.push(`/asset-stock-taking/edit/${id}`);
      //   dispatch(getResource());
      // }
      if (save) {
        history.push('/pre-verification');
      }
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const submitReport = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.put(`/pre-verification/submit-report/${id}`);
      dispatch(fetchSuccess());
      message.success('Report has been Submitted');
      history.push(`/pre-verification`);
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/pre-verification/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const updatePvAssetDetailField = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      if (!payload || !payload._id) {
        message.error('Record not found');
        dispatch(fetchSuccess());
        return;
      }
      const response = await axios.put(`/pre-verification/asset-detail-field-update/${payload._id}`, payload);
      if (response && (response.status === 200 || response.status === 201)) {
        message.success('Updated successfully');
        dispatch(fetchResource(payload._id));
      }
      dispatch(fetchSuccess());
    } catch (error) {
      const msg = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message : 'Update failed';
      message.error(msg);
      dispatch(fetchError(msg));
      console.log("Error****:", msg);
    }
  };
};

export const removePvAssetDetail = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      if (!payload || !payload._id) {
        message.error('Record not found');
        dispatch(fetchSuccess());
        return;
      }
      const response = await axios.put(`/pre-verification/remove-asset-detail/${payload._id}`, payload);
      if (response && (response.status === 200 || response.status === 201)) {
        message.success('Record removed');
        dispatch(fetchResource(payload._id));
      }
      dispatch(fetchSuccess());
    } catch (error) {
      const msg = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message : 'Remove failed';
      message.error(msg);
      dispatch(fetchError(msg));
      console.log("Error****:", msg);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/pre-verification/${id}`);
      if (response && response.data && response.data.deletedCount) {
        message.success('Record deleted successfully');
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const getPVCombineReport = (payload) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const { periodFrom, periodTo, location, subLocation } = payload;
      const response = await axios.get(`/pre-verification/combine-pv-report/${location}/${subLocation}/${periodFrom.format('YYYY-MM-DD')}/${periodTo.format('YYYY-MM-DD')}`);
      // console.log(response.data);
      dispatch(getCombineReportSuccess(response));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getCombineReportSuccess = ({ data }) => {
  return {
    type: GET_PRE_VERIFICATION_COMBINE_REPORT_SUCCESS,
    data
  };
};

export const downloadPVCombineReport = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // console.log(data)
      let maxPhotoSize = 0;
      const listPromise = data.map(async doc => {
        const assetDetail = doc.assetDetails;
        const photos = (assetDetail.photos || []).map((image) => image.url);
        if (photos.length > maxPhotoSize) {
          maxPhotoSize = photos.length
        }
        const meters = (assetDetail.reading || []).map((read) => read && read.meter);
        let docs = [
          doc.pvNo || '',
          doc.location && doc.location.name || '',
          doc.subLocation && doc.subLocation.name || '',
          doc.status || '',
          doc.openedBy && doc.openedBy.name || '',
          doc.date && moment(doc.date).format('DD-MM-YYYY') || '',
          assetDetail && assetDetail.user && assetDetail.user.name || '',
          assetDetail && assetDetail.existingAssetCode || '',
          assetDetail && assetDetail.tempAssetCode || '',
          assetDetail && assetDetail.tempQrCode && assetDetail.tempQrCode.replace('qr#', '') || '',
          assetDetail && assetDetail.parentAssetCode || '',
          assetDetail && assetDetail.assetType && assetDetail.assetType.name || '',
          assetDetail && assetDetail.equipmentSubType && assetDetail.equipmentSubType.name || '',
          assetDetail && assetDetail.assetModel && assetDetail.assetModel.name || '',
          assetDetail && assetDetail.assetCustodian && assetDetail.assetCustodian.name || '',
          assetDetail && assetDetail.physicalCondition && assetDetail.physicalCondition.name || '',
          assetDetail && assetDetail.latitude || '-',
          assetDetail && assetDetail.longitude || '-',
          assetDetail && assetDetail.utilisationLevel || "-",
          (assetDetail && assetDetail.countable) ? 'Yes' : 'No',
          assetDetail && assetDetail.serialNumber || '',
          assetDetail && assetDetail.qty || '',
          assetDetail && assetDetail.time && moment(assetDetail.time).format('hh:mm:ss') || '',
          meters.join("/ "),
        ];
        // console.log(docs);
        for (let i = 0; i < maxPhotoSize; i++) {
          if (photos && photos.length && photos[i])
            docs.push(photos[i])
          else
            docs.push('')
        }
        // console.log(docs);
        return docs;
      }
      );
      const allAssetsData = await Promise.all(listPromise);
      // console.log(allAssetsData);
      const prom = new Promise(resolve => {
        const header = ['PV No',
          'Location',
          'Sub Location',
          'Status',
          'Opened By',
          'Date',
          'User',
          'Existing Code',
          'Temp Code',
          'QR Id',
          'Parent Code',
          'Asset Type',
          'Sub Type',
          'Asset Model',
          'Custodian',
          'Condition',
          'Latitude',
          'Longitude',
          'Utilisation Level',
          'is Countable',
          'Serial Number',
          'Qty',
          'Time',
          'Readings',
        ];
        for (let i = 1; i <= maxPhotoSize; i++) {
          header.push('Attachment_' + i)
        }
        let csvContent = allAssetsData.map(e => e.join(";")).join("\n");
        // console.log(csvContent)
        csvContent = header.join(";") + "\n" + csvContent;
        // console.log(csvContent)
        resolve(csvContent);
      });
      const content = await Promise.all([prom]);
      downloadCSV(content && content.length > 0 && content[0], "pv_combine");

      dispatch(fetchSuccess());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error));

    }
  }
};

export const downloadViewReport = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/pre-verification/${id}`);
      const { data } = response;
      const assets = data.assetDetails;
      let maxPhotoSize = 0;
      const listPromise = assets.map(async doc => {
        const photos = (doc.photos || []).map((image) => image.url);
        if (photos.length > maxPhotoSize) {
          maxPhotoSize = photos.length
        }
        let docs = [
          data.pvNo || '',
          data.location && data.location.name ? data.location.name : '',
          data.client && data.client.name ? data.client.name : '',
          data.status || '',
          // data.submittedBy && data.submittedBy.name || '',
          data.createdAt && moment(data.createdAt).format('DD/MM/YYYY') || '',
          doc.tempAssetCode || '',
          doc.assetModel && doc.assetModel.name ? doc.assetModel.name : '',
          doc.assetType && doc.assetType.name ? doc.assetType.name : '',
          doc.equipmentSubType && doc.equipmentSubType.name ? doc.equipmentSubType.name : '',
          doc.physicalCondition && doc.physicalCondition.name ? doc.physicalCondition.name : '',
          doc.countable ? 'Yes' : 'No',
          doc.qty || 0,
          // doc.manual ? 'Manual' : 'QR Code',
          doc.latitude || '-',
          doc.longitude || '-',
          doc.remark || "",
          doc.time && moment(doc.time).format('DD/MM/YYYY hh:mm a'),
          doc.user && doc.user.name ? doc.user.name : '',
        ];
        return docs.concat(photos);
      }
      );
      const allAssetsData = await Promise.all(listPromise);
      const prom = new Promise(resolve => {
        const header = ['PV', 'Location', 'Client', 'Status', 'Created At', 'Temp Code',
          'Asset Model', 'Asset Type', 'Asset Sub Type', 'Condition', 'Countable', 'Quantity', 'Lat', 'Lng', 'Remark', 'Time', 'User'];
        for (let i = 1; i <= maxPhotoSize; i++) {
          header.push('Attachment_' + i)
        }
        let csvContent = allAssetsData.map(e => e.join(",")).join("\n");
        csvContent = header.join(",") + "\n" + csvContent;
        resolve(csvContent);
      });
      const content = await Promise.all([prom]);
      downloadCSV(content && content.length > 0 && content[0], "pv");
      dispatch(fetchSuccess());

    } catch
    (error) {
      console.log("Error****:", error.message);
      dispatch(fetchError(error && error.response && error.response.data && error.response.data.message || error.message));
    }
  }
};

export const processQrResetForPV = (payload) => {
  // console.log(payload)
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/pre-verification/reset-qr`, payload);
      dispatch(fetchSuccess());
      // console.log(response);
      message.info(`Approval is running in the background, please check in approval list later!`)
      dispatch(processQrResetForPVSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const processQrResetForPVSuccess = ({ data }) => {
  return {
    type: PV_QR_RESET_PROCESS_SUCCESS,
    data
  };
};

export const getPvByVoucher = (voucher) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/pre-verification/pv-by-voucher/${voucher}`);
      dispatch(fetchSuccess());
      dispatch(getPvByVoucherSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getPvByVoucherSuccess = (data) => {
  return {
    type: GET_PV_BY_VOUCHER_SUCCESS,
    data
  };
};
